import { BrowserRouter, Routes, Route, Navigate } from 'react-router-dom'
import { ThemeProvider } from '@/context/ThemeContext'
import { HubAuthProvider } from '@/context/HubAuthContext'
import ProtectedHubRoute from '@/components/hub/ProtectedHubRoute'
import Frontside from '@/pages/Frontside'
import MethodologyPage from '@/pages/Methodology'
import AboutPage from '@/pages/About'
import ProjectDetail from '@/pages/ProjectDetail'
import HubLogin from '@/pages/hub/HubLogin'
import HubLayout from '@/pages/hub/HubLayout'
import HubDashboardPage from '@/pages/hub/HubDashboardPage'
import HubMessengerPage from '@/pages/hub/HubMessengerPage'
import HubEditorPage from '@/pages/hub/HubEditorPage'
import HubEvaluationPage from '@/pages/hub/HubEvaluationPage'
import HubSiteSettingsPage from '@/pages/hub/HubSiteSettingsPage'
import HubProjectPublicPage from '@/pages/hub/HubProjectPublicPage'
import ShareHubProjectPage from '@/pages/hub/ShareHubProjectPage'

export default function App() {
  return (
    <ThemeProvider>
      <HubAuthProvider>
        <BrowserRouter>
          <Routes>
            <Route path="/" element={<Frontside />} />
            <Route path="/methodology" element={<MethodologyPage />} />
            <Route path="/about" element={<AboutPage />} />
            <Route path="/project/hub/:slug" element={<HubProjectPublicPage />} />
            <Route path="/project/:id" element={<ProjectDetail />} />
            <Route path="/share/:token" element={<ShareHubProjectPage />} />
            <Route path="/hub/login" element={<HubLogin />} />
            <Route
              path="/hub"
              element={
                <ProtectedHubRoute>
                  <HubLayout />
                </ProtectedHubRoute>
              }
            >
              <Route index element={<HubDashboardPage />} />
              <Route path="evaluation" element={<HubEvaluationPage />} />
              <Route path="site" element={<HubSiteSettingsPage />} />
              <Route path="messenger" element={<HubMessengerPage />} />
              <Route path="projects/new" element={<HubEditorPage />} />
              <Route path="projects/:slug/edit" element={<HubEditorPage />} />
            </Route>
            <Route path="*" element={<Navigate to="/" replace />} />
          </Routes>
        </BrowserRouter>
      </HubAuthProvider>
    </ThemeProvider>
  )
}
